export const byExtension = (exts: string[]) => (file: File) => exts.some((ext) => file.type.includes(ext));
